<script lang="ts">
    import { createEventDispatcher } from "svelte";

    export const dispatch = createEventDispatcher<{click: undefined}>()
</script>
<button class="btn btn-circle btn-xs btn-ghost" on:click|preventDefault|stopPropagation={() => dispatch("click")}>
    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
</button>
